import React from 'react';

// @ts-expect-error
import * as UserActions from 'actions/UserActions';
import EntityStore from 'stores/EntityStore';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Clipboard from 'ui-library/Clipboard';

const REFERRAL_LINK_BASE = 'https://benchling.com/signup?pubref=';

interface PublicReferralLinkProps {
  email: string;
}

interface ConnectedProps extends PublicReferralLinkProps {
  referralLinkId: string | null;
}

function mapEntityStoreToProps(
  entityStore: typeof EntityStore,
  {email}: PublicReferralLinkProps
): ConnectedProps {
  return {email, referralLinkId: entityStore.getPublicReferralId(email)};
}

class PublicReferralLink extends React.Component<ConnectedProps> {
  componentDidMount(): void {
    UserActions.getOrMakePublicReferralId(this.props.email);
  }

  render(): JSX.Element {
    const link = REFERRAL_LINK_BASE + this.props.referralLinkId;

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleClickClipboard = () => {
      analytics.track('invites', 'copied_referral_link', {
        // @ts-expect-error
        user_id: EntityStore.currentUser()?.id,
        referral_link: link,
      });
    };

    return (
      <div className="u-large-text">
        <p>Post this link to social media, and get credit for anyone who signs up for Benchling with it!</p>
        {this.props.referralLinkId == null ? (
          <code className="copiable-link">Loading...</code>
        ) : (
          <div>
            <code className="copiable-link">{link}</code>
            <Clipboard value={link} onClick={handleClickClipboard}>
              <Tooltip title="Copy to clipboard">
                <Button icon="copy" size={ButtonSize.MINI} buttonStyle={ButtonStyle.TERTIARY_GRAY} />
              </Tooltip>
            </Clipboard>
          </div>
        )}
      </div>
    );
  }
}

export default EntityStore.connect(mapEntityStoreToProps)(PublicReferralLink);
